import styled from "styled-components";

type StyledArrowContainerProps = {
  $size: number;
};

type StyledArrowSpanProps = StyledArrowContainerProps;

export const StyledArrowContainer = styled.div<StyledArrowContainerProps>`
  &.slick-arrow.slick-prev,
  &.slick-arrow.slick-next {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: ${(props) => `${props.$size}rem`};
    height: ${(props) => `${props.$size}rem`};
    z-index: 10;
    cursor: pointer;
  }
`;

export const StyledArrowSpan = styled.span<StyledArrowSpanProps>`
  font-size: ${(props) => `${props.$size}rem`};
  display: flex;

  span,
  svg {
    width: ${(props) => `${props.$size}rem`} !important;
    height: ${(props) => `${props.$size}rem`} !important;
  }
`;
